// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2IdYW","colCheckbox":"styles_colCheckbox__1UiD2"};